import { useBucket } from '@mc/experiments-react'

import { MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG } from './constants'

export const useIsMcCerts280Variant1 = () =>
  useBucket(MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG) === 'variant_1'

export const useIsMcCerts280Variant2 = () =>
  useBucket(MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG) === 'variant_2'
